
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 23 38","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"23","height":"38","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAmCAQAAACFBcgjAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLFyPFRw2YAAAB3klEQVQ4y83UzUtUURzG8U96fQ0thIYsAqFFUYvEIKishGoVYZto2cJtL0bb6C8IRHLhJqmNu0AIXEYJkVALiaDAIhMXRVA6jDam9GvRMMyMM3rb9Vy495yH7z3n+d17zhFCiOZ4HxH5OFvo17jq/NVuBxwx5ZRNVVfSnrdiCyWFZw8u6JTXuulLhVTP4nvMxUJE7E2TfdmQLr1YTpN9TX2xlQL/DVrTjl5XvLek/ZDk0JQGb5Qt5K5Pg2f8xBJ2pcH3+IqcvM6t8SYZH8GsfVvjJ+W9A6/1bYYL0RDTMVb4zX2Rj+7ai0CIezEfHUVrNGajrTZ+LNbieInVHG9iqDY+Hg8rzPOxGq3V8cRp1yvKeWrVCetVCl1OZHwqMTrcNWjBIcM+V8CNkkSDXyVWu5sG/ZKR1V2BH/Qysapxw6Tb5bT7scFfT+SrZGzwBWfMl7mXXEtU16L3Dpsq83pM1amlMbfKYna54kFtfES9EduK1Yx74kVt/Kd+/Sads99lrzQbqNx85XrrqC8e++C+Cb2WEItlK7ArIsRcXCo63REbj6WU+u/wln/BV7SX9HMeoc1SdTwx7YasbOEobTTstu1mcNEAdmAC3PE2cduoSTuLA+TNueoHvpkBz4sz+wMujQ/OaAdo8QAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    